import { TableCellAlignmentEnum } from './TableCellAlignmentEnum';
import { TableColumn } from './TableColumn';
import { TableColumnOptions } from './TableColumnOptions';
import { TableColumnType } from './TableColumnType';

export class TableColumnRadio extends TableColumn {
  public disabled?: boolean;
  private readonly callback: (selectedId: number | null, row?: any) => void;
  private _selectedId: number;
    public initialSelectedId?: any;
    public initialSelectedRow?: any;

  public set selectedId(value: number) {
    this._selectedId = value;
  }

  constructor(
    def: string,
    header: string,
    callback: (selectedId: number | null) => void,
    sortable = false,
    width?: number,
    options?: TableColumnOptions,
    disabled?: boolean,
  ) {
    if (options == null) {
      options = {
        alignment: TableCellAlignmentEnum.CENTER,
        columnType: TableColumnType.Radio,
      };
    }
    super(def, header, () => '', sortable, width, options);
    this.disabled = disabled ?? false;
    this.callback = callback;
  }

  public clickHandler(event: MouseEvent, rowId: number, row?: any): void {
    if (event) {
      event.stopPropagation();
    }

    this._selectedId = rowId;
    this.showChecked(rowId);
    this.callback(this._selectedId, row);
  }

  public showChecked(rowId: number): boolean {
    if (this._selectedId == null) {
      return false;
    }
    return this._selectedId == rowId;
  }

  public clearSelection(): void {
    this._selectedId == null;
  }
}
